import { ButtonGroup, GroupButton } from 'ui/buttonGroup';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, spacing, button } from 'ui/theme';

export const StyledButtonGroup = styled(ButtonGroup)`
  display: inline-block;
  padding: 0;
  margin: ${spacing.half};
  margin-left: 0;
`;

export const StyledButton = styled(GroupButton)`
  ${button}
  padding-left: ${spacing.half};
  padding-right: ${spacing.half};
  background: ${colors.white};
  color: ${colors.grey50};
`;

export const ZoomButton = styled(StyledButton)`
  min-width: ${pxToRem(55)};
  margin: 0 -${spacing.single};
  border-radius: 0 !important;
`;
